module.exports = __webpack_public_path__ + "media/images/icons/vendors/webpic/accessories-a7ff7c88cb50ec4395bb7fd940241a88.webp";